<template>
  <div class="left">
    <h2>
      {{ title }}
    </h2>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'app-settings-desc',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
